import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { CountdownTimer } from '../ui/CountdownTimer';
import { ShieldCheck, Gift } from 'lucide-react';
interface PricingProps {
  onBuyClick?: () => void;
}
export function Pricing({
  onBuyClick
}: PricingProps) {
  return <section id="pricing" className="py-20 px-4 bg-cream-dark" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border border-gold/20 relative overflow-hidden" data-id="element-69">
          {/* Ribbon */}
          <div className="absolute top-6 -right-12 bg-rose-600 text-white font-bold py-1 px-12 rotate-45 shadow-md" data-id="element-70">
            92% OFF
          </div>

          <div className="text-center mb-10" data-id="element-71">
            <Gift className="w-16 h-16 text-gold mx-auto mb-6" data-id="element-72" />
            <p className="text-xl text-chocolate-light mb-6 leading-relaxed" data-id="element-73">
              Si compraras cada Ebook por separado, el valor sería de{' '}
              <span className="line-through decoration-rose-500 decoration-2 font-bold" data-id="element-74">
                $94 USD
              </span>
              . Es lo que vale mi experiencia y cada estrategia probada.
            </p>
            <p className="text-2xl font-serif text-chocolate font-bold mb-8" data-id="element-75">
              Pero hoy, por lanzamiento, quiero que el costo no sea una excusa
              para tu progreso.
            </p>

            <div className="bg-cream p-8 rounded-2xl border-2 border-gold/30 mb-8 inline-block w-full md:w-auto min-w-[300px]" data-id="element-76">
              <p className="text-sm uppercase tracking-widest text-chocolate-light font-bold mb-2" data-id="element-77">
                Llévate el Bundle Completo por solo
              </p>
              <div className="flex items-center justify-center gap-2 text-chocolate" data-id="element-78">
                <span className="text-3xl font-bold" data-id="element-79">$</span>
                <span className="text-7xl font-black tracking-tighter" data-id="element-80">
                  6.39
                </span>
                <span className="text-xl font-bold self-end mb-2" data-id="element-81">USD</span>
              </div>
              <span className="inline-block mt-3 bg-rose-600 text-white text-sm font-bold px-4 py-1 rounded-full" data-id="element-82">
                93% DE DESCUENTO
              </span>
              <p className="text-sm text-rose-600 font-bold mt-2" data-id="element-83">
                (Pago único, acceso de por vida)
              </p>
            </div>
          </div>

          <div id="pricing-cta" className="flex flex-col items-center gap-6" data-id="element-84">
            <Button className="w-full md:w-auto md:px-12 py-5 text-xl" onClick={onBuyClick} data-id="element-85">
              ¡SÍ, QUIERO MI NEGOCIO DE REPOSTERÍA — ACCESO INMEDIATO POR $6.39!
            </Button>

            <div className="flex flex-col items-center gap-3" data-id="element-86">
              <p className="text-sm text-chocolate-light font-medium" data-id="element-87">
                La oferta expira en:
              </p>
              <CountdownTimer className="text-rose-600 bg-rose-50 px-4 py-2 rounded-lg text-xl" data-id="element-88" />
            </div>

            <div className="flex items-center gap-2 text-sm text-chocolate-light mt-4" data-id="element-89">
              <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-90" />
              <span data-id="element-91">Compra 100% segura.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}